var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 49,
    viewBox: "0 0 46 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.687 7.89743L23.8166 0.268332C23.2938 0.0772695 22.7061 0.0771758 22.1834 0.268332L1.31302 7.89743C0.518139 8.18806 0 8.87131 0 9.62909V18.9033C0 31.6733 8.76651 43.1602 22.1952 47.986C22.711 48.1713 23.2889 48.1713 23.8048 47.986C37.2333 43.1603 46 31.6734 46 18.9033V9.62909C46 8.87131 45.482 8.18806 44.687 7.89743ZM41.7407 18.9033C41.7407 29.7591 34.5 39.7526 23 44.2134C11.8073 39.8717 4.25926 30.0533 4.25926 18.9033V10.8808L23 4.03015L41.7407 10.8808V18.9033ZM20.6461 25.2234L29.7997 17.1643C30.6313 16.4322 31.9797 16.4321 32.8114 17.1643C33.6431 17.8966 33.643 19.0838 32.8113 19.816L22.152 29.2008C21.3201 29.9332 19.9718 29.9329 19.1403 29.2008L13.1886 23.9608C12.3569 23.2285 12.3569 22.0413 13.1886 21.3091C14.0203 20.5769 15.3687 20.5768 16.2003 21.3091L20.6461 25.2234Z",
    fill: "#ABE138"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldIcon);
export default __webpack_public_path__ + "static/media/shield-icon.86460b38a55c36919e092581a87812a4.svg";
export { ForwardRef as ReactComponent };